
import { Text, Flex } from 'rebass';
import React, { useRef, useCallback, useEffect } from 'react';
import { CgArrowRightR, CgDetailsLess } from "react-icons/cg";
import { FaRegTrashAlt, FaRegEdit } from "react-icons/fa";
import useOutsideClick from 'use-onclickoutside';
import Tippy from '@tippy.js/react';

import { TooltipWrap } from 'stories/story-detail-header/styled';
import { ChapterList } from 'stories/list/item/index';
import { BsPlusCircleFill } from "react-icons/bs";
import DetailHeaderButton from 'app/detail/button';
import useToggle from 'app/hooks/toggle';
import DeleteModal from '../../delete/modal';
import useHistory from 'app/hooks/history';
import useEntities from 'entities/hooks/use-entities';
import { useDrawer } from 'contexts/DrawerContext';


const EditingOptions = ({ chapterName, story, handleEditSettingClick, updateChapter }) => {
    const [on, toggle] = useToggle();
    const [isTooltipOpen, setTooltipOpen] = useToggle();
    const [addToChapter, setAddToChapter] = useToggle();
    const allChapters = useEntities('chapter')
    const { openFirstTimeUserModal } = useDrawer();

    const wrapper = useRef(null);
    const addToChapterWrapper = useRef(null);

    const { push } = useHistory();

    const onEdit = useCallback(() => {
        const pathname = story && `/story/${story.id}/edit`;
        push({ pathname });
    }, [push, story]);


    useOutsideClick(wrapper, () => {
        if (isTooltipOpen)
            setTooltipOpen()
    });

    useOutsideClick(addToChapterWrapper, () => {
        if (addToChapter)
            setAddToChapter()
    });

    useEffect(() => {
        if (chapterName)
            setTooltipOpen()
    }, [chapterName])

    return (
        <Flex justifyContent="space-between" width="100%" alignItems="center">
            {on && <DeleteModal onClose={toggle} storyID={story?.id} />}

            {chapterName ? (
                <Flex alignItems="center" color="#000">
                    <Text css="    max-width: 165px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: break-spaces;"
                        title={chapterName}
                        textAlign="left" fontSize="14px" fontFamily="Poppins" color="#64748B"

                    >
                        {chapterName}
                    </Text>
                </Flex>
            ) : (Object.keys(allChapters || {}) || []).length === 0 ? null : <Tippy
                content={
                    <TooltipWrap ref={addToChapterWrapper} style={{ width: 270 }} >
                        <Text fontFamily="Poppins" fontSize={18} py={2} lineHeight="165%" sx={{
                            boxShadow: '0px 1px 0px 0px #F0F0F0'
                        }}>Add to chapter:</Text>
                        <ChapterList
                            storyID={story?.id}
                            updateChapter={updateChapter}
                        />
                    </TooltipWrap>
                }
                interactive
                theme="light"
                trigger="manual"
                onClickOutside={setAddToChapter}
                placement="bottom-end"
                visible={addToChapter}
            >
                <DetailHeaderButton px={0} p={0} size="unset" iconcolor="#9B59B6" labelProps={{ color: '#9B59B6', fontSize: ['14px', '16px'] }} label={"Add to Chapter"} icon={BsPlusCircleFill} onClick={() => {
                    openFirstTimeUserModal(setAddToChapter)
                }} />
            </Tippy>}
            <Tippy
                content={<TooltipWrap>
                    <DetailHeaderButton iconcolor={"#64748B"} labelProps={{ color: '#64748B' }} label="Story Header" icon={CgDetailsLess} onClick={handleEditSettingClick} />
                    <DetailHeaderButton iconcolor={"#64748B"} labelProps={{ color: '#64748B' }} label="Edit Story" icon={FaRegEdit} onClick={onEdit} />

                    {(Object.keys(allChapters || {}) || []).length === 0 ? null : <Tippy
                        content={
                            <TooltipWrap ref={wrapper} style={{ width: 270 }}>
                                <Text fontFamily="Poppins" fontSize={18} py={2} lineHeight="165%" sx={{
                                    boxShadow: '0px 1px 0px 0px #F0F0F0'
                                }}>Add to chapter:</Text>
                                <ChapterList
                                    storyID={story?.id}
                                    updateChapter={updateChapter}
                                />
                            </TooltipWrap>
                        }
                        interactive
                        onClickOutside={setTooltipOpen}
                        theme="light"
                        trigger="manual"
                        placement="bottom-end"
                        visible={isTooltipOpen}
                    >
                        <DetailHeaderButton iconcolor={isTooltipOpen ? '#0E0E0E' : '#64748B'} labelProps={{ color: isTooltipOpen ? '#0E0E0E' : '#64748B' }} label="Move to Chapter" icon={CgArrowRightR}
                            onClick={setTooltipOpen}
                            bg={isTooltipOpen ? '#F5EEF8' : 'white'}
                        />
                    </Tippy>}
                    <DetailHeaderButton iconcolor={"#64748B"} labelProps={{ color: '#64748B' }} label="Delete Story" icon={FaRegTrashAlt} onClick={toggle} />
                </TooltipWrap>}
                interactive
                theme="light"
                trigger="click"
                placement="top-end"
            >
                <Flex
                    justifyContent="center"
                    alignItems="center"
                    height={["32px", "40px"]}
                    width={["32px", "40px"]}

                    css="border-radius: 5px;background: #FFF;box-shadow: 0 0 5px 0 rgba(155, 89, 182, 0.15) inset; cursor: pointer;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" fill="#9B59B6" stroke="#9B59B6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z" fill="#9B59B6" stroke="#9B59B6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z" fill="#9B59B6" stroke="#9B59B6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </Flex>
            </Tippy>
        </Flex>
    )
}

export default EditingOptions;